import React, { useContext } from "react";

import { Thumbs } from "@/components/Thumbs";
import { ThumbsProps } from "@/containers/Thumbs";
import { GlobalContext } from "@/contexts";
import LocaleContext from "@/i18n";

import {
  Header,
  HiddenCount,
  Placeholder,
  ThumbsWrapper,
  ThumbWrapper,
  Title,
  Wrapper,
} from "./styles";

const ClassicThumbs: React.FC<ThumbsProps> = (
  props: ThumbsProps
): JSX.Element => {
  const globalContext = useContext(GlobalContext);
  const localeContext = useContext(LocaleContext);
  const {
    interaction,
    thumbsUpCount,
    thumbsDownCount,
    thumbsDownSelected,
    onVote,
    thumbsUpSelected,
    voted,
  } = props;

  const renderThumbs = (): JSX.Element => {
    return (
      <React.Fragment>
        <ThumbWrapper>
          <Thumbs
            label={`${localeContext.translation.yes}!`}
            count={thumbsUpCount}
            showCount={!interaction.hideResults}
            highlighted={thumbsUpSelected}
            disabled={thumbsDownSelected}
            iconContents={globalContext.icons?.ThumbsUp || ""}
            onClick={() => onVote(true)}
          />
          {interaction.hideResults && (
            <Placeholder>
              {voted && (
                <HiddenCount data-qa="thumbs:count">
                  {thumbsUpCount}
                </HiddenCount>
              )}
            </Placeholder>
          )}
        </ThumbWrapper>
        <ThumbWrapper>
          <Thumbs
            label={`${localeContext.translation.no}!`}
            count={thumbsDownCount}
            showCount={!interaction.hideResults}
            highlighted={thumbsDownSelected}
            disabled={thumbsUpSelected}
            iconContents={globalContext.icons?.ThumbsDown || ""}
            iconStyles={{
              bottom: "-9px",
            }}
            onClick={() => onVote(false)}
          />
          {interaction.hideResults && (
            <Placeholder>
              {voted && (
                <HiddenCount data-qa="thumbs:count">
                  {thumbsDownCount}
                </HiddenCount>
              )}
            </Placeholder>
          )}
        </ThumbWrapper>
      </React.Fragment>
    );
  };

  return (
    <Wrapper>
      <Header data-qa="header">
        <Title>{interaction.title}</Title>
      </Header>
      <ThumbsWrapper>{renderThumbs()}</ThumbsWrapper>
    </Wrapper>
  );
};

export default ClassicThumbs;
